import dataTimeService from "../services/dataTime.service";

const HOURS_ONLY_PATTERN = /^(\d+)\s*h$/i;
const HOURS_MINUTES_SPACED_PATTERN = /^(\d+)\s*h\s*(\d+)\s*(?:min|m)$/i;
const HOURS_MINUTES_COMPACT_PATTERN = /^(\d+)h(\d+)(?:min|m)?$/i;

export function parseResourceAllocationDurationInput(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  if (dataTimeService.isValidTime(trimmed)) {
    const minutes = dataTimeService.convertStringToMin(trimmed);
    if (!minutes || minutes <= 0) {
      return null;
    }
    return minutes;
  }

  const hoursOnlyMatch = trimmed.match(HOURS_ONLY_PATTERN);
  if (hoursOnlyMatch) {
    const hours = parseInt(hoursOnlyMatch[1], 10);
    if (hours <= 0) {
      return null;
    }
    return hours * 60;
  }

  const hoursMinutesMatch =
    trimmed.match(HOURS_MINUTES_SPACED_PATTERN) ??
    trimmed.match(HOURS_MINUTES_COMPACT_PATTERN);

  if (hoursMinutesMatch) {
    const hours = parseInt(hoursMinutesMatch[1], 10);
    const minutes = parseInt(hoursMinutesMatch[2], 10);
    if (hours < 0 || minutes < 0 || minutes >= 60) {
      return null;
    }
    const totalMinutes = hours * 60 + minutes;
    if (totalMinutes <= 0) {
      return null;
    }
    return totalMinutes;
  }

  return null;
}

export function formatResourceAllocationDuration(minutes: number): string {
  if (minutes <= 0) {
    return "0h";
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (remainingMinutes === 0) {
    return `${hours}h`;
  }

  return `${hours}h ${remainingMinutes}min`;
}
